import React, { useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./privacyPolicy.css"; // Assuming you have a CSS file for styling
import files from "../../../assets/img/privacy_policy/files.svg";
import codicon_graph_line from "../../../assets/img/privacy_policy/codicon_graph_line.svg";
import proicons_cookies from "../../../assets/img/privacy_policy/proicons_cookies.svg";
import material_symbols from "../../../assets/img/privacy_policy/material_symbols.svg";
import light_globe from "../../../assets/img/privacy_policy/light_globe.svg";
import ion_call_outline from "../../../assets/img/privacy_policy/ion_call-outline.svg";
import iconoir_privacy_policy from "../../../assets/img/privacy_policy/iconoir_privacy_policy.svg";

const sections = [
  {
    id: "collected-info",
    title: "What We Do with Collected Information",
    img: files,
    description: (
      <>
        <p>
          We use personal information so that we may display custom,
          personalized content to our visitors and send newsletters, emails,
          features, promotional material, surveys and other updates to our
          users. A user may, at any time, opt out of receiving such information.
          We also use collected information to evaluate and administer our
          service, respond to any problems that may arise and to gauge user
          trends to determine what part of our services are most popular with
          users.
        </p>
        <p>
          We may extend offers to users on behalf of our partners about a
          particular product or service that may be of interest to you, but we
          will never give out your name or personal information at any time
          without your permission. As result, although UAIC may receive a fee
          from our partners for this service, UAIC sends all the offers so that
          your personal information is never shared with any outside third
          party.
        </p>
        <p>
          We may, at times, produce reports for advertisers containing aggregate
          information about our users such as demographic, age and online usage
          information. This allows us to work more closely with advertisers to
          provide content and offers that are most relevant to our users. We
          will never include any personal information of our users in these
          reports.
        </p>
        <p>
          We allow users of our Web site to send articles or links by email to
          other parties who may be interested in them. We do not retain any
          email addresses (unless you are a member who already has voluntarily
          provided your email address) of either the sender or recipient of such
          articles or links after they are sent.
        </p>
        <p>
          We reserve the right to use or disclose any information without notice
          or consent as needed to satisfy any law, regulation or legal request;
          to conduct investigations of consumer complaints or possible breaches
          of law; to protect the integrity of our site and our property; to
          protect the safety of our visitors or others; to fulfill your
          requests; or to cooperate in any legal investigation.
        </p>
        <p>
          You should be aware that if you voluntarily disclose information
          online (whether through UAIC's services or any other service available
          online), personal or otherwise, that information can be collected and
          used by others. For example, if you use chat, forums, bulletin boards,
          your e-mail or if you post personal information online, you may
          receive unsolicited messages from others. UAIC has no control over
          this use of your personal information.
        </p>
      </>
    ),
  },
  //UNCOMMENT below
  {
    id: "termsofuse",
    title: "Text Messaging Terms of use",
    img: ion_call_outline,
    description: (
      <>
        <p>
          Text Messaging Terms of use: By providing your phone number you agree
          to receive customer care, billing or claims related text messages from{" "}
          <b>UAIC</b>. Message and data rates may apply. Message frequency
          varies. For help, you may call{" "}
          <a href="tel:3059405022">(305)-940-5022</a> for support. You can opt
          out at any time by replying <b>STOP</b>.
        </p>
      </>
    ),
  },
  {
    id: "cookies",
    title: "Use of Cookies",
    img: proicons_cookies,
    description: (
      <>
        <p>
          Your browser offers so-called "cookies" which, if you allow their use,
          store small amounts of data on your computer when you visit a Web
          site. Cookies do not contain any personally identifiable information
          about you and therefore cannot be used to identify you personally.
          Cookies simply assist us in tracking which of our features you like
          best. Cookies also enable us to customize our content according to
          your preferences. You have the ability to accept or decline cookies by
          modifying your browser and our Web sites are viewable even if you
          disable the cookie function on your browser. However, if you disable
          cookies, some advanced and customized features of our site, as well as
          other Web sites, will not be available to you.
        </p>
      </>
    ),
  },
  {
    id: "web-beacons",
    title: "Use of Web Beacons",
    img: files,
    description: (
      <>
        <p>
          Some of our Web pages may contain electronic images known as Web
          beacons, which are also called single-pixel gif's. These images allow
          us to count users who have visited those pages and to deliver
          co-branded services. We also may include Web beacons in promotional
          e-mail messages or newsletters in order to count how many messages
          have been opened and acted upon. Web beacons are not used to access
          your personally identifiable information but they are a technique we
          use to compile aggregated statistics about our Web site usage. Web
          beacons collect only a limited set of information including a cookie
          number, time and date of a page view, originating IP address, and a
          description of the page on which the Web beacon resides. Some of our
          Web pages may also contain Web beacons placed there by our advertising
          partners to help us determine the effectiveness of our advertising
          campaigns.
        </p>
      </>
    ),
  },
  {
    id: "control-info",
    title: "Controlling Your Personal Information",
    img: files,
    description: (
      <>
        <p>
          Users can unsubscribe from any newsletters or opt out of various
          promotional emailings at any time by clicking on "unsubscribe" links
          in each of our newsletters or emails.
        </p>
        <p>
          No mobile information will be shared with third parties/affiliates for
          marketing/promotional purposes. Information sharing to subcontractors
          in support services, such as customer service, is permitted. All other
          use case categories exclude text messaging originator opt-in data and
          consent; this information will not be shared with any third parties.
        </p>
      </>
    ),
  },
  {
    id: "security-info",
    title: "Security of Your Personal Information",
    img: material_symbols,
    description: (
      <>
        <p>
          UAIC employees are made aware of its privacy practices through
          periodic communications and training. We limit access to private and
          confidential data only to those employees with a specific need to
          retrieve this information and we store data on multiple service
          systems, in controlled, secure environments. To maintain our level of
          security, we conduct both internal reviews and external audits of our
          security measures and procedures on a regular basis.
        </p>
      </>
    ),
  },
  {
    id: "corporate-changes",
    title: "Changes in Corporate Structure",
    img: files,
    description: (
      <>
        <p>
          In developing our business, we might sell certain assets or the
          company, or parts of it, may be sold, merged or otherwise transferred.
          In such transactions, user information, whether personally
          identifiable or otherwise, may be one of the transferred assets.
        </p>
      </>
    ),
  },
  {
    id: "outside-us",
    title: "Visitors Outside the United States",
    img: light_globe,
    description: (
      <>
        <p>
          Our Web site and the servers that make this site available worldwide
          are located in the United States. All matters relating to these sites
          are governed by the laws of the State of New York in the United
          States. Any information you provide will be transferred to the United
          States. By visiting our sites and submitting information, you
          authorize this transfer.
        </p>
      </>
    ),
  },
  {
    id: "policy-changes",
    title: "Changes to Our Website Privacy Policy",
    img: iconoir_privacy_policy,
    description: (
      <>
        <p>
          We will occasionally update this Website Privacy Policy as necessary
          to maintain the highest protection for our users and to comply with a
          changing environment. We recommend that you check the policy when you
          visit our site to be sure you are aware of and understand our current
          policy. If we make material changes to this policy or in how we will
          use or collect your personally identifiable information, we will
          prominently post such changes prior to implementing the change. We
          will not make changes in how we handle previously collected personal
          information that have retroactive effect unless legally required to do
          so.
        </p>
      </>
    ),
  },
  {
    id: "contact",
    title: "Contact Information",
    img: ion_call_outline,
    description: (
      <>
        <p>
          If you have any questions about our Website Privacy Policy or our
          website privacy practices, please visit us at our{" "}
          <Link to="/uaichome/contact">contact</Link> us section.
        </p>
      </>
    ),
  },
];

const PrivacyPolicy = () => {
  const [activeId, setActiveId] = useState("collected-info");

  const scrollToSection = (id) => {
    setActiveId(id);
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 border-end py-4">
          <h5 className="custom-heading">What UAIC Offers</h5>

          <ul className="list-unstyled">
            {sections.map((section) => (
              <li
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`py-2 px-3 mb-1 ${
                  activeId === section.id
                    ? "border-left-2 fw-bold bg-light border-start border-primary text-dark"
                    : "text-secondary"
                }`}
                style={{ cursor: "pointer", borderLeftWidth: "5px" }}
              >
                {section.title}
              </li>
            ))}
          </ul>
        </div>

        {/* Main Content */}
        <div className="col-md-9 py-4">
          <section className="mb-3 mt-3">
            <div className="d-flex">
              <img
                src={files}
                alt="PC Icon"
                className="me-2"
                style={{ width: "35px", height: "35px" }}
              />
              <h5 className="fw-semibold" style={{ paddingTop: "5px" }}>
                United Automobile Insurance Company Website Privacy Policy
              </h5>
            </div>
            <p className="text-muted mt-2">
              UAIC is strongly committed to protecting your privacy and
              providing a safe online experience for all our users. This Privacy
              Policy applies to information collected online through UAIC's Web
              site, which includes all of the UAIC Agent-Sites and governs
              online data collection and usage by UAIC.Please read the complete
              UAIC Website Privacy Policy below and{" "}
              <Link to="/uaichome/contact">contact</Link> us if you have any
              questions.
            </p>
          </section>
          <hr />
          <section className="mb-3 mt-3">
            <div className="d-flex">
              <img
                src={codicon_graph_line}
                alt="PC Icon"
                className="me-2"
                style={{ width: "35px", height: "35px" }}
              />
              <h5 className="fw-semibold" style={{ paddingTop: "5px" }}>
                Collection and Tracking of Personal Information
              </h5>
            </div>
            <p className="text-muted mt-2">
              So that we can provide you with the most efficient and enhanced
              service, we request information about you. We collect personally
              identifiable information such as names, email addresses and
              demographic information such as age, gender and zip code. We also
              may collect your IP address, browser type, domain name, access
              times and referring Web site address. This information is
              collected both during registration on a site or in response to
              specific requests, for example when signing up for a newsletter,
              entering a sweepstakes or contest or answering a survey.
              Information collected at one UAIC Web site will be available
              within the UAIC family of Web sites.
            </p>
          </section>
          <hr />
          {sections.map((section) => (
            <>
              <section id={section.id} key={section.id} className="mb-3 mt-3">
                <div className="d-flex">
                  <img
                    src={section.img}
                    alt="PC Icon"
                    className="me-2"
                    style={{ width: "35px", height: "35px" }}
                  />
                  <h5 className="fw-semibold" style={{ paddingTop: "5px" }}>
                    {section.title}
                  </h5>
                </div>
                {/* <div
                  className="text-muted mt-2"
                  dangerouslySetInnerHTML={{ __html: section.description }}
                ></div> */}
                <div className="text-muted mt-2">{section.description}</div>
              </section>
              <hr />
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
